import styled from 'styled-components';
import { TextField } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(TextField) `
  && {
    .MuiInputBase-root {
      ${theme.typography.bodyLG};
      border-color: ${theme.colors.borderDark};
      border-radius: ${theme.spacing.xs};
      color: ${theme.colors.textTertiary};

      &:hover {
        color: ${theme.colors.text};

        .MuiOutlinedInput-notchedOutline {
          border-color: ${theme.colors.borderBrand};
        }

        &.Mui-error {
          .MuiOutlinedInput-notchedOutline {
            border-color: ${theme.colors.errorForeground};
          }
        }
      }

      &.Mui-focused {
        color: ${theme.colors.text};
        outline: 4px solid #eae8f2;

        &.Mui-error {
          outline: 4px solid ${theme.colors.errorBackground};

          .MuiOutlinedInput-notchedOutline {
            border-color: ${theme.colors.errorForeground};
            border-width: 1px;
          }
        }

        .MuiOutlinedInput-notchedOutline {
          border-color: ${theme.colors.borderBrand};
          border-width: 1px;
        }
      }
    }

    .MuiInputBase-input {
      height: auto;
      padding: calc(${theme.spacing.xs} + 1px) ${theme.spacing.md};
    }
  }
`;
